/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationRejectedTombstoneContainer_comment = {
    readonly id: string;
    readonly spamBanned: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"CaretContainer_comment">;
    readonly " $refType": "ModerationRejectedTombstoneContainer_comment";
};
export type ModerationRejectedTombstoneContainer_comment$data = ModerationRejectedTombstoneContainer_comment;
export type ModerationRejectedTombstoneContainer_comment$key = {
    readonly " $data"?: ModerationRejectedTombstoneContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationRejectedTombstoneContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationRejectedTombstoneContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CaretContainer_comment"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "spamBanned",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = '01cbb37eb78731b9d891c8fbff80acb6';
export default node;
